import React from "react";
//import { makeStyles } from '@mui/styles';
import { makeStyles } from '@mui/styles';

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import axios from "../../src/utils/axiosConfig";
import TextField from "@mui/material/TextField";
import CompletedDashboardGrid from "../components/CompletedDashboardGrid";
import { useSelector, useDispatch } from "react-redux";
import { setButtonArray, getButtonArray, getLoading } from "../reducer/dashboardSlice";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";


import { LoadingSkeletonTableWise } from "../components/LoadingSkeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  btnPadding: {
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    fontSize: "0.775rem",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    '@media (max-width: 600px)': {
      minHeight: '120px',
    },
  },
  content: {
    flexGrow: 80,
    padding: theme.spacing(3),
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  pageTitle: {
    color: "#7030a0",
    fontSize: "20px",
    '@media (max-width: 600px)': {
      fontSize: "18px",
    },
  },
  searchContainer: {
    display: "flex",
    paddingLeft: "0",
    paddingRight: "0",
    flexWrap: "wrap",
    gap: "16px",
    '@media (max-width: 600px)': {
      flexDirection: "column",
      gap: "12px",
    },
  },
  searchInputWrapper: {
    padding: "0",
    flex: "1 1 300px",
    minWidth: "200px",
    '@media (max-width: 600px)': {
      flex: "1 1 100%",
      width: "100%",
    },
  },
  searchButtonWrapper: {
    padding: "0",
    alignSelf: "center",
    textAlign: "center",
    '@media (max-width: 600px)': {
      width: "100%",
      "& button": {
        width: "100%",
      },
    },
  },
  tableWrapper: {
    overflowX: "auto",
    marginTop: theme.spacing(2),
    '& .MuiTable-root': {
      '@media (max-width: 900px)': {
        minWidth: '800px',
      },
    },
  },
  actionButton: {
    '@media (max-width: 600px)': {
      fontSize: '0.7rem',
      padding: '4px 8px',
      minWidth: 'auto',
    },
  },
  // Mobile card styles
  mobileContainer: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
  desktopContainer: {
    display: 'block',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  mobileCard: {
    background: '#fff',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #f0f0f0',
    boxSizing: 'border-box',
  },
  cardHeader: {
    marginBottom: '12px',
    paddingBottom: '12px',
    borderBottom: '1px solid #f0f0f0',
  },
  examInfo: {
    flex: 1,
  },
  examName: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#333',
    margin: '0 0 4px 0',
    wordBreak: 'break-word',
  },
  orgName: {
    fontSize: '13px',
    color: '#666',
    margin: '0 0 6px 0',
  },
  idBadge: {
    fontSize: '11px',
    color: '#6f2981',
    backgroundColor: 'rgba(111, 41, 129, 0.1)',
    padding: '4px 10px',
    borderRadius: '12px',
    fontWeight: 600,
    display: 'inline-block',
  },
  cardBody: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  infoLabel: {
    fontSize: '11px',
    color: '#999',
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  infoValue: {
    fontSize: '13px',
    color: '#333',
    fontWeight: 500,
    wordBreak: 'break-word',
  },
  statusBadge: {
    display: 'inline-block',
    padding: '3px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: 600,
  },
  statusCompleted: {
    backgroundColor: 'rgba(76, 175, 80, 0.1)',
    color: '#2e7d32',
  },
  statusInProgress: {
    backgroundColor: 'rgba(255, 152, 0, 0.1)',
    color: '#e65100',
  },
  statusFailed: {
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    color: '#c62828',
  },
  statusDefault: {
    backgroundColor: '#f5f5f5',
    color: '#666',
  },
  cardFooter: {
    gridColumn: 'span 2',
    marginTop: '8px',
    paddingTop: '12px',
    borderTop: '1px solid #f0f0f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  percentage: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#6f2981',
  },
  noDataCard: {
    textAlign: 'center',
    padding: '32px 16px',
    color: '#666',
  },
}));
export default function FullWidthGrid(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { buttonName, setButtonClicked } = props;
  // const {handleDownlaodReport, process} = props;
  const buttonArray = useSelector(getButtonArray);
  const _loading = useSelector(getLoading);
  const [username, setUsername] = React.useState("");
  const [Organization, setOrganization] = React.useState();
  const [organizationId, setOrganizationId] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState();
  const [userId, setUserId] = React.useState();
  const [searchRecord, setSearchRecord] = React.useState(true);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_selectTypeButton, setSelectedType] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [manualGenerate, setManualGenerate] = React.useState(false);
  const [completedData, setCompleted] = React.useState(false);
  const [isSearchLoading, setIsSearchLoading] = React.useState(false);
  const findOrganizations = () => {
    setIsSearchLoading(true)
    axios
      .post("/test/searchUserOrg", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        username: username,
      })
      .then((response) => {
        if (response.data.success === false) {
          setErrorMessage(response.data.message);
        } else {
          setOrganization(response.data.data);
        }
        setIsSearchLoading(false)
      })
      .catch((error) => {
        console.log("Error findOrganizations", error);
        setErrorMessage("Something went wrong !!");
        setIsSearchLoading(false)
      });
  };

  const onChange = (event) => {
    // dispatch(setButtonArray())
    setUserId();
    setOrganization();
    setErrorMessage();
    setOrganizationId();
    setUsername(event.target.value);
  };

  const searchData = (data) => {
    axios
      .post("/test/searchRecord", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        userId: userId,
        orgId: data !== undefined ? data : organizationId,
      })
      .then((response) => {
        setIsLoading(false);
        dispatch(setButtonArray(response.data.groups));
      })
      .catch((error) => {
        console.log("Error searchRecord", error);
      });
  };

  const handleTestRegeneration = async (data) => {
    console.log("data", data);
    await axios
      .post("/test/regenratetest", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        data,
      })
      .then((response) => {
        if (response.success === false) {
          setErrorMessage(response.message)
        } else {
          Organization.find(item => item.userexams_id === data.userExamId).queued = true
          setOrganization([...Organization])
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  React.useEffect(() => {
    setSearchRecord(true);
  }, []);

  React.useEffect(() => {
    if (completedData) {
      searchData(organizationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completedData]);

  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />

        <div className="row" style={{ display: "flex" }}>
          <Grid item xs={12}>
            <b>
              <h3 className={classes.pageTitle}>Search User Details</h3>
            </b>
          </Grid>
        </div>

        <div className="row">
          <div className={classes.searchContainer}>
            <div className={classes.searchInputWrapper}>
              <TextField
                style={{ margin: "0" }}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="username"
                label="Enter User Email-Id"
                type="username"
                id="username"
                onChange={(event) => onChange(event)}
              />
              {errorMessage ? (
                <div className="username-error" style={{ color: "red", marginTop: "4px" }}>
                  {errorMessage}
                </div>
              ) : (
                ""
              )}
            </div>

            <div className={classes.searchButtonWrapper}>
              <Button type="submit" variant="contained" color="primary" className={classes.submit} onClick={findOrganizations}>
                Search User Tests
              </Button>
            </div>
          </div>

          <div className={classes.tableWrapper}>
            {isSearchLoading ? (
              <LoadingSkeletonTableWise />
            ) : (
              <>
                {/* Mobile Card Layout */}
                <div className={classes.mobileContainer}>
                  {Organization && Organization.length !== 0 ? (
                    Organization.map((row, index) => (
                      <div key={`mobile-${index}`} className={classes.mobileCard}>
                        <div className={classes.cardHeader}>
                          <p className={classes.examName}>{row.exam_name}</p>
                          <p className={classes.orgName}>{row.org_name}</p>
                          <span className={classes.idBadge}>ID: {row.userexams_id}</span>
                        </div>
                        <div className={classes.cardBody}>
                          <div className={classes.infoItem}>
                            <span className={classes.infoLabel}>Start Time</span>
                            <span className={classes.infoValue}>{row.start_timestamp || '-'}</span>
                          </div>
                          <div className={classes.infoItem}>
                            <span className={classes.infoLabel}>End Time</span>
                            <span className={classes.infoValue}>{row.finish_timestamp || '-'}</span>
                          </div>
                          <div className={classes.infoItem}>
                            <span className={classes.infoLabel}>Test Status</span>
                            <span className={`${classes.statusBadge} ${row.status === "010" ? classes.statusCompleted :
                              row.status === "001" ? classes.statusInProgress :
                                row.status === "999" || row.status === "111" ? classes.statusFailed :
                                  classes.statusDefault
                              }`}>
                              {row.status === "000" ? "Not Started" :
                                row.status === "001" ? "In Progress" :
                                  row.status === "010" ? "Completed" :
                                    row.status === "011" ? "Time Out" :
                                      row.status === "111" ? "Web Proctoring Aborted" :
                                        row.status === "112" ? "System Aborted" :
                                          row.status === "113" ? "Image Proctoring Aborted" : row.status === "114" ? "Speaker Proctoring Aborted" :
                                            row.status === "999" ? "Result Failed" :
                                              row.status === "100" ? "Expired" : "-"}
                            </span>
                          </div>
                          <div className={classes.infoItem}>
                            <span className={classes.infoLabel}>Result Status</span>
                            <span className={`${classes.statusBadge} ${row.result_status === "010" ? classes.statusCompleted :
                              row.result_status === "001" ? classes.statusInProgress :
                                row.result_status === "999" || row.result_status === "111" ? classes.statusFailed :
                                  classes.statusDefault
                              }`}>
                              {row.result_status === "000" ? "Not Started" :
                                row.result_status === "001" ? "In Progress" :
                                  row.result_status === "010" ? "Completed" :
                                    row.result_status === "011" ? "Time Out" :
                                      row.result_status === "111" ? "Aborted" :
                                        row.result_status === "999" ? "Result Failed" :
                                          row.result_status === "100" ? "Expired" : "-"}
                            </span>
                          </div>
                          <div className={classes.cardFooter}>
                            <span className={classes.percentage}>{row.percentage ? `${row.percentage}%` : '-'}</span>
                            {row.queued === true || row.already_in_queue === true || row.mongodb_skipped === true ? (
                              <Button variant="contained" color="primary" disabled size="small">
                                {row.mongodb_skipped === true ? "SKIPPED" : row.queued === true ? "QUEUED" : "IN QUEUE"}
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => handleTestRegeneration({ userExamId: row.userexams_id, userId: row.user_id, examInstanceId: row.examinstance_id })}
                              >
                                Regenerate
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={classes.noDataCard}>No data available</div>
                  )}
                </div>

                {/* Desktop Table Layout */}
                <div className={classes.desktopContainer}>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>ID</TableCell>
                          <TableCell>Org Name</TableCell>
                          <TableCell>Exam Name</TableCell>
                          <TableCell>Start Time</TableCell>
                          <TableCell>End Time</TableCell>
                          <TableCell>Test Status</TableCell>
                          <TableCell>Result Status</TableCell>
                          <TableCell>Percentage</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Organization && Organization.length !== 0 ? Organization.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell>{row.userexams_id}</TableCell>
                            <TableCell>{row.org_name}</TableCell>
                            <TableCell>{row.exam_name}</TableCell>
                            <TableCell>{row.start_timestamp}</TableCell>
                            <TableCell>{row.finish_timestamp}</TableCell>
                            <TableCell>
                              {row.status === "000" ? "Not Started" :
                                row.status === "001" ? "In Progress" :
                                  row.status === "010" ? "Completed" :
                                    row.status === "011" ? "Time Out" :
                                      row.status === "111" ? "Web Proctoring Aborted" :
                                        row.status === "112" ? "System Aborted" :
                                          row.status === "113" ? "Image Proctoring Aborted" : row.status === "114" ? "Speaker Proctoring Aborted" :
                                            row.status === "999" ? "Result Failed" :
                                              row.status === "100" ? "Expired" : null}
                            </TableCell>
                            <TableCell>
                              {row.result_status === "000" ? "Not Started" :
                                row.result_status === "001" ? "In Progress" :
                                  row.result_status === "010" ? "Completed" :
                                    row.result_status === "011" ? "Time Out" :
                                      row.result_status === "111" ? "Aborted" :
                                        row.result_status === "999" ? "Result Failed" :
                                          row.result_status === "100" ? "Expired" : null}
                            </TableCell>
                            <TableCell>{row.percentage}</TableCell>
                            <TableCell>
                              {row.queued === true || row.already_in_queue === true || row.mongodb_skipped === true ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled
                                  className={classes.actionButton}
                                  sx={{ fontSize: { xs: '0.65rem', sm: '0.8rem' }, whiteSpace: 'nowrap' }}
                                >
                                  {row.mongodb_skipped === true ? "SKIPPED" : row.queued === true ? "QUEUED" : row.already_in_queue === true ? "IN QUEUE" : "-"}
                                </Button>
                              ) : (
                                <Button
                                  type="submit"
                                  variant="contained"
                                  color="primary"
                                  className={classes.actionButton}
                                  onClick={() => handleTestRegeneration({ userExamId: row.userexams_id, userId: row.user_id, examInstanceId: row.examinstance_id })}
                                >
                                  Regenerate
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        )) : (
                          <TableRow>
                            <TableCell style={{ textAlign: "center" }} colSpan="100%">
                              No data available in this table.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>
            )}
          </div>

          {/* {Organization ? (
              <>
                <div className="col-md-4" style={{ textAlign: "right", fontSize: "large", marginTop: "1rem", padding: "0" }}>
                  Select Organization :
                </div>
                <div className="col-md-4">
                  <FormControl style={{ width: "-webkit-fill-available" }}>
                    <InputLabel id="demo-simple-select-helper-label">Organization</InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      label="organization"
                      onChange={handleChange}
                      name="org-select"
                      value={organizationId || ""}
                      options={Organization}
                    >
                      {Organization &&
                        Organization.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.organization_id}>
                              {item.org_name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </>
            ) : (
              ""
            )} */}
        </div>
        {organizationId !== undefined ? (
          <CompletedDashboardGrid
            setCompleted={setCompleted}
            setManualGenerate={setManualGenerate}
            manualGenerate={manualGenerate}
            dispatch={dispatch}
            buttonArray={buttonArray}
            buttonName={buttonName}
            setButtonClicked={setButtonClicked}
            typeButton={"Completed"}
            loading={isLoading}
            selectTypeButton={"COMPLETED"}
            setSelectedType={"COMPLETED"}
            searchRecord={searchRecord}
          // handleDownlaodReport={handleDownlaodReport} process={process}
          />
        ) : (
          ""
        )}
      </main>
    </>
  );
}
